import { fansupportPublic } from "../index";

export const getTournamentSeasons= async ({ tournamentId }) => {
    return fansupportPublic.get('/sport/tournament-seasons',{ params: { 
        tournamentId,
    }})
}